// AI工具翻译

export const tools = {
    weddingPhoto: {
      title: '婚纱照',
      description: '支持中式/西式风格选择，打造浪漫婚纱照',
      features: ['多图上传', '风格选择', '可选提示词'],
      ui: {
        uploadTitle: '上传照片',
        uploadDescription: '最多支持 {max} 张，可预览与移除',
        promptTitle: '补充提示词（选填）',
        promptDescription: '可描述场景、服装、氛围与细节',
        promptPlaceholder: '例如：户外仪式、柔和打光、优雅构图',
        styleLabel: '婚纱风格',
        styles: {
          chinese: '中式婚纱',
          western: '西式婚纱'
        }
      }
    },
    emojiPack: {
      title: '表情包制作',
      description: '上传一张图片，一键生成一整套风格统一的表情包',
      features: ['图片上传', '尺寸选择', '补充提示词', '多图生成']
    },
    groupPhoto: {
      title: '合照',
      description: '从多张照片生成高质量多人合照',
      features: ['多图上传', '多人合成', '可选提示词'],
      ui: {
        uploadTitle: '上传合照素材',
        uploadDescription: '最多支持 {max} 张，可预览与移除',
        promptTitle: '补充提示词（选填）',
        promptDescription: '可描述场景、氛围与人物站位',
        promptPlaceholder: '例如：办公室团队照、专业打光、自然姿态'
      }
    },
    popArtPortrait: {
      title: '波普艺术肖像',
      description: '将普通照片转换为充满活力的波普艺术风格',
      features: ['鲜艳色彩', '艺术风格', '个性化']
    },
    animeStyle: {
      title: '动漫风格转换',
      description: '将真实照片转换为精美的动漫风格插画',
      features: ['动漫效果', '二次元', '插画风格']
    },
    oilPainting: {
      title: '油画风格',
      description: '模拟传统油画技法，创造经典艺术作品',
      features: ['油画质感', '艺术风格', '经典美学']
    },
    watercolor: {
      title: '水彩画风格',
      description: '创造柔和透明的水彩画艺术效果',
      features: ['水彩效果', '柔和色调', '艺术感']
    },
    sketchStyle: {
      title: '素描风格',
      description: '转换为精细的铅笔素描或炭笔画',
      features: ['素描效果', '线条艺术', '黑白处理']
    },
    cyberpunk: {
      title: '赛博朋克风格',
      description: '创造未来科技感的赛博朋克艺术风格',
      features: ['科技感', '霓虹效果', '未来风格']
    },
    faceSwap: {
      title: 'AI 捏脸',
      description: '上传一张包含人脸的图片，即可生成不同风格的头像',
      features: ['AI 捏脸', '多种风格', '头像生成']
    },
    professionalPortrait: {
      title: '职业肖像照',
      description: '将照片转换为专业的商务肖像',
      features: ['商务风格', '专业打光', '企业适用']
    },
    photoRestoration: {
      title: '图片修复',
      description: '修复老旧、损坏或褪色的照片，去除划痕、污渍和瑕疵',
      features: ['老照片修复', '去除瑕疵', '色彩恢复']
    },
    imageUpscaler: {
      title: '图像放大器',
      description: '使用AI技术提升图像分辨率和质量',
      features: ['AI增强', '高分辨率', '质量提升']
    },
    imageMatting: {
      title: '智能抠图',
      description: '自动移除图片背景，生成透明背景图片',
      features: ['自动去背', '高精度识别', '透明背景'],
      ui: {
        uploadTitle: '上传图片',
        uploadDescription: '支持 JPG, PNG 格式',
        downloadTitle: '下载结果',
        downloadDescription: '下载透明背景图片'
      }
    },
    worldView: {
      title: '全球打卡',
      description: '在谷歌地图选点，获取当地天气与位置信息，生成合照',
      features: ['谷歌地图选点', '实时天气', '多人合成'],
      ui: {
        uploadTitle: '上传照片',
        uploadDescription: '支持多图上传，可预览与移除',
        promptTitle: '提示词',
        promptDescription: '描述场景、服装、氛围与细节',
        promptPlaceholder: '例如：清晨海边，写实，保留人物服装与身份，真实光影'
      },
      mapCard: {
        title: '地图资讯',
        description: '从地图选择位置并填充到卡片',
        location: '位置',
        coords: '坐标',
        weather: '天气',
        notSelected: '未选择',
        loading: '加载中…',
        openMapButton: '选择地图位置',
        searchPlaceholder: '搜寻地点',
        confirmButton: '使用此位置',
        selectedPoint: '已选择：',
        resolving: '解析中…'
      }
    }
  };
